// @flow

import * as React from 'react';
import {useContext} from 'react';
import {ContentGroupItem, contextStubFunction} from 'docs/util';

export type ContentGroupContextType = {|
  items: Array<ContentGroupItem>,
  onItemSelected: (item: ContentGroupItem) => void,
  selectedItem: ContentGroupItem,
|};

/**
 * The ContentGroupContext allows components within a ContentGroup to see the
 * items within the ContentGroup, as well as change the currently-selected one.
 * It's primarily used to implement Selectors. (See TabSelector and DropDownSelector.)
 */
export const ContentGroupContext = React.createContext<ContentGroupContextType>(
  {
    items: [],
    onItemSelected: contextStubFunction('ContentGroup'),
    selectedItem: ({}: any),
  },
);

export const useContentGroup = () => {
  return useContext(ContentGroupContext);
};
